import React, {
    Component, lazy, Suspense, useRef, useState, useEffect,
} from 'react';
import { connect, useSelector } from 'react-redux';
import { axiosInstance, inIframe } from '@appblocks/frontend/client/utils';
import TawkMessengerReact from '@tawk.to/tawk-messenger-react';
import { useLocation } from 'react-router-dom';
const mapStateToProps = (state) => {
    return {
        user: state.user.user,
    };
};

const TawkComponent = () => {
    // get page from react hook
    const location = useLocation();
    const tawkMessengerRef = useRef();
    const user = useSelector(state => state.user.user);
    const [isTawkLoaded, setIsTawkLoaded] = useState(false);

    useEffect(() => {
        if (tawkMessengerRef.current == null || user == null || !isTawkLoaded) {
            return;
        }
        if (user.email) {
            tawkMessengerRef.current.setAttributes({
                userId: user.id,
                reference: user.id,
                name: user.email,
                email: user.email,
                hash: user.id,
            }, (error) => {
                if (error) {
                    console.log(error);
                }
            });
        }
    }, [user, isTawkLoaded]);

    if (inIframe() || window.location.hostname === 'localhost') {
        return null;
    }

    return (
        <TawkMessengerReact
            propertyId="6821bac844abcc190d947a79"
            widgetId="1ir1t45vi"
            onLoad={() => setIsTawkLoaded(true)}
            // customStyle={{
            //     visibility: {
            //         desktop: {
            //             position: 'br',
            //             yOffset: 40,
            //         },
            //     },
            // }}
            ref={tawkMessengerRef}
        />
    );
};

export default connect(mapStateToProps, {})(TawkComponent);
